
import { delay } from "@common/helpers";
import { HubConnection, HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { Writable, writable } from "svelte/store";
import { AppendPath } from "./helpers";
import { service } from "./services";
import { Startup } from "./startup";
import { BACKEND_SAME_ORIGIN, DEVELOPMENT } from "./version";
import { CashierServerHub } from "./walletapi";
import "./listrealtime";


export const connectionStatus: Writable<boolean> = writable(false);

let defaultServer = new URL(`${window.location.origin}`);

if (DEVELOPMENT && !BACKEND_SAME_ORIGIN)
{
	defaultServer.port = "5010";
}

const urlParams = new URLSearchParams(window.location.search);
const overwriteServer = urlParams.get("server")
export const server: URL = overwriteServer ? new URL(overwriteServer) : defaultServer;

service.UpdateServer(server);

export const walletApiServer = AppendPath(server, "/wallet");


let connection: HubConnection = new HubConnectionBuilder()
    .withUrl(walletApiServer.toString())
	.withAutomaticReconnect({
		nextRetryDelayInMilliseconds: (retryContext) => {
			// if (retryContext.previousRetryCount < 5)
			// {
			// 	return 1000;
			// }
			// else if (retryContext.previousRetryCount < 10)
			// {
			// 	return 5000;
			// }
			// else
			// {
			// 	return 10000;
			// }
			return 1000;
		}
	})
	.configureLogging(LogLevel.Error)
    .build();

service.UpdateConnection(connection);

connection.onclose(async () => {
	service.UpdateConnected(false);
	connectionStatus.set(false);
});

connection.onreconnecting(async (error) => {
	service.UpdateConnected(false);
	connectionStatus.set(false);
});

connection.onreconnected(async (connectionId) => {
	await onConnected(false);

	service.UpdateConnected(true);
	connectionStatus.set(true);
});

export const api: CashierServerHub = new CashierServerHub(connection)
service.UpdateApi(api);

async function connect()
{
	while (true)
	{
		try
		{
			await service.connection.start();
			break;
		}
		catch (e)
		{
			
		}

		await delay(1000);
	}
	
	await onConnected(true);

	service.UpdateConnected(true);
	connectionStatus.set(true);
}

async function onConnected(firstConnection: boolean)
{
	await Startup(firstConnection);
}

connect();

